export class EVENTS_CONFIG {

  // 遷移用のイベント
  static readonly SET_ROOT = 'event:SET_ROOT';

  static readonly LOGIN = 'event:LOGIN';
  static readonly LOGIN_OFFLINE = 'event:LOGIN_OFFLINE';
  static readonly LOGOUT = 'event:LOGOUT';
  static readonly INITLOGOUT = 'event:INITLOGOUT';

  static readonly AUTH_LICENSE_KEY = 'event:AUTH_LICENSE_KEY';

  static readonly LICENSE_KEY = 'event:LICENSE_KEY';
  static readonly TOKEN = 'event:TOKEN';
  static readonly API_URL = 'event:API_URL';
  static readonly UUID = 'event:UUID';
  // static readonly EVENT_NETWORK = 'event:network';
  static readonly VERSION_UP = 'event:VERSION_UP';
  static readonly MAINTENANCE = 'event:MAINTENANCE';

  // ダッシュボード情報取得
  static readonly LOADED_DASHBOARD = 'event:LOADED_DASHBOARD';

  // スタッフリスト取得
  static readonly LOAD_STAFFS = 'event:LOAD_STAFFS';

  // 患者リスト取得
  static readonly LOAD_PATIENTS = 'event:LOAD_PATIENTS';
  static readonly LOADED_PATIENTS = 'event:LOADED_PATIENTS';

  // トースト表示
  static readonly SHOW_COMMON_TOAST = 'event:SHOW_COMMON_TOAST';

  // モーダル表示
  static readonly SHOW_COMMON_MODAL = 'event:SHOW_COMMON_MODAL';

  // ローディング
  static readonly SHOW_LOADING = 'event:SHOW_LOADING';
  static readonly CLOSE_LOADING = 'event:CLOSE_LOADING';


}



// WEBPACK FOOTER //
// ./src/configs/events.config.ts